import intl from 'react-intl-universal';
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { searchProductBySeries } from '@/api/systemSetting';
import { GoodType } from '@/type/components';
import { Table, Image } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useEffect } from 'react';
import { useState } from 'react';

type ProductTableSelectProps = {
    series: string;
    value?: GoodType;
    onChange?: (product?: GoodType) => void;
    countLimit?: boolean;
};

const ProductTableSelect: React.FC<ProductTableSelectProps> = ({
    series,
    value,
    onChange,
    countLimit = false,
}) => {
    const [dataSource, setDataSource] = useState<GoodType[]>([]);
    const [selectedRowKeys, setSelectRowKeys] = useState<string[]>(
        value ? [value.productCode] : [],
    );

    useEffect(() => {
        onChange && onChange(undefined);

        // 请求数据
        if (series) {
            searchProductBySeries(series).then((result) => {
                if (result) {
                    setDataSource(result);
                    // 默认不选
                    // if (!value) {
                    //     const first = result.find((item) =>
                    //         countLimit ? item.availableStock > 0 : true,
                    //     );

                    //     first && setSelectRowKeys([first.productCode]);

                    //     first && onChange && onChange(first);
                    // } else {
                    //     onChange?.(value);
                    // }
                    if (value) {
                        onChange?.(value);
                    }
                }
            });
        }
    }, [series]);

    const columns: ColumnsType<GoodType> = [
        {
            title: intl.get('商品名'),
            dataIndex: 'productName',
            width: 200,
        },
        {
            title: intl.get('图片'),
            dataIndex: 'productImage',
            render: (text) => {
                return (
                    <Image
                        width={30}
                        src={text}
                    />
                );
            },
            width: 50,
        },
        {
            title: intl.get('包装类型'),
            dataIndex: 'packagingType',
            width: 80,
        },
        {
            title: intl.get('上市时间'),
            dataIndex: 'putawayTime',
            width: 150,
        },
        {
            title: intl.get('库存'),
            dataIndex: 'availableStock',
            width: 50,
            render: (text: number) => {
                if (text === 0 || !text) {
                    return intl.get('无库存');
                } else if (text >= 1 && text <= 5) {
                    return intl.get('有风险');
                } else {
                    return intl.get('可使用');
                }
            },
        },
    ];

    const change = (selectedKeys: string[], selectedRecords: GoodType[]) => {
        setSelectRowKeys(selectedKeys);
        if (onChange) {
            onChange(selectedRecords[0]);
        }
    };
    const getCheckboxProps = (record: GoodType) => {
        return {
            disabled: countLimit ? record.availableStock <= 0 : false,
        };
    };

    return (
        <Table
            // width: 750,, x: true
            style={{ width: '100%', paddingBottom: 20 }}
            bordered={true}
            pagination={false}
            scroll={{ y: 500 }}
            rowKey="productCode"
            rowSelection={{
                type: 'radio',
                onChange: change,
                getCheckboxProps,
                selectedRowKeys,
            }}
            columns={columns}
            dataSource={dataSource}
        />
    );
};

export default ProductTableSelect;
